webpackJsonp([170844033123148],{

/***/ "./assets/animation/vasano_frame1.gif":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vasano_frame1.d736a324.gif";

/***/ }),

/***/ "./assets/animation/vasano_frame2.gif":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vasano_frame2.8886e38b.gif";

/***/ }),

/***/ "./assets/animation/vasano_frame3.gif":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vasano_frame3.79c4fce1.gif";

/***/ }),

/***/ "./assets/animation/vasano_frame4.gif":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vasano_frame4.9d1119cb.gif";

/***/ }),

/***/ "./assets/dashed.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAPCAYAAAAs9AWDAAAABGdBTUEAALGPC/xhBQAAADZJREFUGBljnD59+n8GNMCExgdzWYBkIzYJ4sQYibYIq+3ECxLnHJAqkJMa0JWDvFmPLojVdgDQ7wjlQp1HDAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./assets/product/check-circular-button.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./assets/product/eco-cell.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./assets/product/happiness.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./assets/product/stopwatch.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./assets/product/time.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA8CAYAAAAkNenBAAAABGdBTUEAALGPC/xhBQAABOtJREFUaAXtWltIVEEYbt11tXoJQoPAAgVlrZciEyqhCNJ2vaZSL0H5UFAoRBffkoIgQl80erKM0Iew8pIuEb0lhor2FKKiIGJUBEoRed++fzmT49lzmTN7ttbVA8OcM/PP9/3/fP+cM7Pq8Pl83YFAwLtlHV8Oh8Mft479N3bd6/UGqBhb/b9ePf9iRhGX3txGsypaPseMIlrBhbTp5WWIoc0NVnhjRpHNQGzOorDhNhUJewptBtjYitBGk4rNkxoWnO6X3Qg1GnfLGyu1sN//TQqVl5dvpZo9l5SU7KTnSFxqLjMOUUUmCWhubi5VARykemFh4abybHvFcQW5zQiEAoECAwS0srJyhmo83yJVsFaqsR96AWWSqd3Oi+MKcpthCwUCkCcKUFVhYeGurq6uDwikDG0/UEqhzKf8/Pyzik3YFXEApEoBYtyGuA7DXq6Tne0RQE98fHxBe3v7bFFRUcri4mIjzE4ppi8TEhKutLW1feOGWrotLi7eAczXUPsYuPzd3d0+EQBRRbY4nc4KAE4RARTogwKHOzo6pvx+f25cXNwl9AXVmZ+ffydCrGWDNM0mbOIgLoVTyzSkzRnSotMwMjLyy+PxPAfJCZjsR6lIT0/flpeX9765ubk/MzOzBXm9B7M4ODY29lYHRrO5srIyISkp6R7GPoZBEuohl8t1srOz84vmAI1G4dRiY4l0fHz8LsiuIygn6mGUC1g3/czGSk3KAucpigc4y6jr0tLSbjc0NMxbwbEcCAOnNABxE3MA7bWpqak1og7QhExMTNzBuBvACE4I6otI1T7GYaUWTi01KNJnGmnVODMz40ZAR+BEzuzsbGlGRsbA6OjotNqefyYVMO4NxhRjLP30VAsVzrW0tEzydlbupRXhSUTVsVsF3gdpRXgQEXUioQLvgy2K8IBqdZA+ddSPFPr7cghnLfBc/L0tivCAanXQl4Ny1K61wHPx98IfRH6QyL3i+BpTrbY1BmE82J5aWt8F8o9PLdxLf3f0YrUtELM3knrtwCFL3x29AFi7LWtE5I2kXjtWvjvMWaM6LEXMVNAjjoQ60oqIqKAXSCTUsayIlgrhLF71ywHBS60dS4Hg5LZ7eXmZDj0H4bz0TlWtFE2Oakc9hLNIAbbxn9W2es/CgdDxc2lpic7PKSijOEydl926K6fNZGBc5TFo7QD7GUo6yhTOJFkI5ivuTS/hDyKCaAJaCpTocbvd2bwDpiwqAyi6HU2HUPciqPukCJnQFp6wiQOPKVBf6LxOY4UCQR4fh+1pEHyH5GV0XqfBshe27LkY+4DGI5hqnEs+0lqhZ8ImDuJCn1fhpi7DSygQIFQoKPWiUhux0uELs18NR2kPNozag9KL1LpM4xSOegWDcRtBiikCkixCQU6/MkSz2EmphFPlAQwjdRCT4xGCKSIYxsW4qc3oElVkL4EkJiZOGIHJ9HHqXIPT5E8N4XBcQW4zbKFAQBD8zbe1tTX4G7AZqEw/3lD0MiFZ9lHNuBg3tRldQoEYAdjVh3Xxk7DguFsGU+rvIzJEgmMCgnYhZlEVCNLqYYiHgg1RFQh+52U/XAu6v2oWNWtk1SW5u81A5OYtcqM2FYnc3Mohh5xHsNeRfpfLuSA3Cvu0Nb7HTGrpfkfUEcvNm/2j9DImZhRxsL/W2j93/w4RW5vY+U/sP+wFsiyuYAvdAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./node_modules/animejs/anime.min.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 2017 Julian Garnier
	 Released under the MIT license
	*/
	var $jscomp$this=this;
	(function(v,p){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (p), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof module&&module.exports?module.exports=p():v.anime=p()})(this,function(){function v(a){if(!g.col(a))try{return document.querySelectorAll(a)}catch(b){}}function p(a){return a.reduce(function(a,d){return a.concat(g.arr(d)?p(d):d)},[])}function w(a){if(g.arr(a))return a;g.str(a)&&(a=v(a)||a);return a instanceof NodeList||a instanceof HTMLCollection?[].slice.call(a):[a]}function F(a,b){return a.some(function(a){return a===b})}
	function A(a){var b={},d;for(d in a)b[d]=a[d];return b}function G(a,b){var d=A(a),c;for(c in a)d[c]=b.hasOwnProperty(c)?b[c]:a[c];return d}function B(a,b){var d=A(a),c;for(c in b)d[c]=g.und(a[c])?b[c]:a[c];return d}function S(a){a=a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(a,b,d,h){return b+b+d+d+h+h});var b=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);a=parseInt(b[1],16);var d=parseInt(b[2],16),b=parseInt(b[3],16);return"rgb("+a+","+d+","+b+")"}function T(a){function b(a,b,c){0>
	c&&(c+=1);1<c&&--c;return c<1/6?a+6*(b-a)*c:.5>c?b:c<2/3?a+(b-a)*(2/3-c)*6:a}var d=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a);a=parseInt(d[1])/360;var c=parseInt(d[2])/100,d=parseInt(d[3])/100;if(0==c)c=d=a=d;else{var e=.5>d?d*(1+c):d+c-d*c,l=2*d-e,c=b(l,e,a+1/3),d=b(l,e,a);a=b(l,e,a-1/3)}return"rgb("+255*c+","+255*d+","+255*a+")"}function x(a){if(a=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|pc|vw|vh|deg|rad|turn)?/.exec(a))return a[2]}function U(a){if(-1<a.indexOf("translate"))return"px";
	if(-1<a.indexOf("rotate")||-1<a.indexOf("skew"))return"deg"}function H(a,b){return g.fnc(a)?a(b.target,b.id,b.total):a}function C(a,b){if(b in a.style)return getComputedStyle(a).getPropertyValue(b.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function I(a,b){if(g.dom(a)&&F(V,b))return"transform";if(g.dom(a)&&(a.getAttribute(b)||g.svg(a)&&a[b]))return"attribute";if(g.dom(a)&&"transform"!==b&&C(a,b))return"css";if(null!=a[b])return"object"}function W(a,b){var d=U(b),d=-1<b.indexOf("scale")?
	1:0+d;a=a.style.transform;if(!a)return d;for(var c=[],e=[],l=[],h=/(\w+)\((.+?)\)/g;c=h.exec(a);)e.push(c[1]),l.push(c[2]);a=l.filter(function(a,c){return e[c]===b});return a.length?a[0]:d}function J(a,b){switch(I(a,b)){case "transform":return W(a,b);case "css":return C(a,b);case "attribute":return a.getAttribute(b)}return a[b]||0}function K(a,b){var d=/^(\*=|\+=|-=)/.exec(a);if(!d)return a;b=parseFloat(b);a=parseFloat(a.replace(d[0],""));switch(d[0][0]){case "+":return b+a;case "-":return b-a;case "*":return b*
	a}}function D(a){return g.obj(a)&&a.hasOwnProperty("totalLength")}function X(a,b){function d(c){c=void 0===c?0:c;return a.el.getPointAtLength(1<=b+c?b+c:0)}var c=d(),e=d(-1),l=d(1);switch(a.property){case "x":return c.x;case "y":return c.y;case "angle":return 180*Math.atan2(l.y-e.y,l.x-e.x)/Math.PI}}function L(a,b){var d=/-?\d*\.?\d+/g;a=D(a)?a.totalLength:a;if(g.col(a))b=g.rgb(a)?a:g.hex(a)?S(a):g.hsl(a)?T(a):void 0;else{var c=x(a);a=c?a.substr(0,a.length-c.length):a;b=b?a+b:a}b+="";return{original:b,
	numbers:b.match(d)?b.match(d).map(Number):[0],strings:b.split(d)}}function Y(a,b){return b.reduce(function(b,c,e){return b+a[e-1]+c})}function M(a){return(a?p(g.arr(a)?a.map(w):w(a)):[]).filter(function(a,d,c){return c.indexOf(a)===d})}function Z(a){var b=M(a);return b.map(function(a,c){return{target:a,id:c,total:b.length}})}function aa(a,b){var d=A(b);if(g.arr(a)){var c=a.length;2!==c||g.obj(a[0])?g.fnc(b.duration)||(d.duration=b.duration/c):a={value:a}}return w(a).map(function(a,c){c=c?0:b.delay;
	a=g.obj(a)&&!D(a)?a:{value:a};g.und(a.delay)&&(a.delay=c);return a}).map(function(a){return B(a,d)})}function ba(a,b){var d={},c;for(c in a){var e=H(a[c],b);g.arr(e)&&(e=e.map(function(a){return H(a,b)}),1===e.length&&(e=e[0]));d[c]=e}d.duration=parseFloat(d.duration);d.delay=parseFloat(d.delay);return d}function ca(a){return g.arr(a)?y.apply(this,a):N[a]}function da(a,b){var d;return a.tweens.map(function(c){c=ba(c,b);var e=c.value,l=J(b.target,a.name),h=d?d.to.original:l,h=g.arr(e)?e[0]:h,m=K(g.arr(e)?
	e[1]:e,h),l=x(m)||x(h)||x(l);c.isPath=D(e);c.from=L(h,l);c.to=L(m,l);c.start=d?d.end:a.offset;c.end=c.start+c.delay+c.duration;c.easing=ca(c.easing);c.elasticity=(1E3-Math.min(Math.max(c.elasticity,1),999))/1E3;g.col(c.from.original)&&(c.round=1);return d=c})}function ea(a,b){return p(a.map(function(a){return b.map(function(b){var c=I(a.target,b.name);if(c){var d=da(b,a);b={type:c,property:b.name,animatable:a,tweens:d,duration:d[d.length-1].end,delay:d[0].delay}}else b=void 0;return b})})).filter(function(a){return!g.und(a)})}
	function O(a,b,d){var c="delay"===a?Math.min:Math.max;return b.length?c.apply(Math,b.map(function(b){return b[a]})):d[a]}function fa(a){var b=G(ga,a),d=G(ha,a),c=Z(a.targets),e=[],g=B(b,d),h;for(h in a)g.hasOwnProperty(h)||"targets"===h||e.push({name:h,offset:g.offset,tweens:aa(a[h],d)});a=ea(c,e);return B(b,{children:[],animatables:c,animations:a,duration:O("duration",a,d),delay:O("delay",a,d)})}function n(a){function b(){return window.Promise&&new Promise(function(a){return Q=a})}function d(a){return f.reversed?
	f.duration-a:a}function c(a){for(var b=0,c={},d=f.animations,e={};b<d.length;){var g=d[b],h=g.animatable,m=g.tweens;e.tween=m.filter(function(b){return a<b.end})[0]||m[m.length-1];e.isPath$1=e.tween.isPath;e.round=e.tween.round;e.eased=e.tween.easing(Math.min(Math.max(a-e.tween.start-e.tween.delay,0),e.tween.duration)/e.tween.duration,e.tween.elasticity);m=Y(e.tween.to.numbers.map(function(a){return function(b,c){c=a.isPath$1?0:a.tween.from.numbers[c];b=c+a.eased*(b-c);a.isPath$1&&(b=X(a.tween.value,
	b));a.round&&(b=Math.round(b*a.round)/a.round);return b}}(e)),e.tween.to.strings);ia[g.type](h.target,g.property,m,c,h.id);g.currentValue=m;b++;e={isPath$1:e.isPath$1,tween:e.tween,eased:e.eased,round:e.round}}if(c)for(var k in c)E||(E=C(document.body,"transform")?"transform":"-webkit-transform"),f.animatables[k].target.style[E]=c[k].join(" ");f.currentTime=a;f.progress=a/f.duration*100}function e(a){if(f[a])f[a](f)}function g(){f.remaining&&!0!==f.remaining&&f.remaining--}function h(a){var h=f.duration,
	l=f.offset,n=f.delay,P=f.currentTime,q=f.reversed,r=d(a),r=Math.min(Math.max(r,0),h);if(f.children){var p=f.children;if(r>=f.currentTime)for(var u=0;u<p.length;u++)p[u].seek(r);else for(u=p.length;u--;)p[u].seek(r)}r>l&&r<h?(c(r),!f.began&&r>=n&&(f.began=!0,e("begin")),e("run")):(r<=l&&0!==P&&(c(0),q&&g()),r>=h&&P!==h&&(c(h),q||g()));a>=h&&(f.remaining?(t=m,"alternate"===f.direction&&(f.reversed=!f.reversed)):(f.pause(),"Promise"in window&&(Q(),R=b()),f.completed||(f.completed=!0,e("complete"))),
	k=0);e("update")}a=void 0===a?{}:a;var m,t,k=0,Q=null,R=b(),f=fa(a);f.reset=function(){var a=f.direction,b=f.loop;f.currentTime=0;f.progress=0;f.paused=!0;f.began=!1;f.completed=!1;f.reversed="reverse"===a;f.remaining="alternate"===a&&1===b?2:b;for(a=f.children.length;a--;)b=f.children[a],b.seek(b.offset),b.reset()};f.tick=function(a){m=a;t||(t=m);h((k+m-t)*n.speed)};f.seek=function(a){h(d(a))};f.pause=function(){var a=q.indexOf(f);-1<a&&q.splice(a,1);f.paused=!0};f.play=function(){f.paused&&(f.paused=
	!1,t=0,k=d(f.currentTime),q.push(f),z||ja())};f.reverse=function(){f.reversed=!f.reversed;t=0;k=d(f.currentTime)};f.restart=function(){f.pause();f.reset();f.play()};f.finished=R;f.reset();f.autoplay&&f.play();return f}var ga={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},ha={duration:1E3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},V="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY".split(" "),
	E,g={arr:function(a){return Array.isArray(a)},obj:function(a){return-1<Object.prototype.toString.call(a).indexOf("Object")},svg:function(a){return a instanceof SVGElement},dom:function(a){return a.nodeType||g.svg(a)},str:function(a){return"string"===typeof a},fnc:function(a){return"function"===typeof a},und:function(a){return"undefined"===typeof a},hex:function(a){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)},rgb:function(a){return/^rgb/.test(a)},hsl:function(a){return/^hsl/.test(a)},col:function(a){return g.hex(a)||
	g.rgb(a)||g.hsl(a)}},y=function(){function a(a,d,c){return(((1-3*c+3*d)*a+(3*c-6*d))*a+3*d)*a}return function(b,d,c,e){if(0<=b&&1>=b&&0<=c&&1>=c){var g=new Float32Array(11);if(b!==d||c!==e)for(var h=0;11>h;++h)g[h]=a(.1*h,b,c);return function(h){if(b===d&&c===e)return h;if(0===h)return 0;if(1===h)return 1;for(var m=0,k=1;10!==k&&g[k]<=h;++k)m+=.1;--k;var k=m+(h-g[k])/(g[k+1]-g[k])*.1,l=3*(1-3*c+3*b)*k*k+2*(3*c-6*b)*k+3*b;if(.001<=l){for(m=0;4>m;++m){l=3*(1-3*c+3*b)*k*k+2*(3*c-6*b)*k+3*b;if(0===l)break;
	var n=a(k,b,c)-h,k=k-n/l}h=k}else if(0===l)h=k;else{var k=m,m=m+.1,f=0;do n=k+(m-k)/2,l=a(n,b,c)-h,0<l?m=n:k=n;while(1e-7<Math.abs(l)&&10>++f);h=n}return a(h,d,e)}}}}(),N=function(){function a(a,b){return 0===a||1===a?a:-Math.pow(2,10*(a-1))*Math.sin(2*(a-1-b/(2*Math.PI)*Math.asin(1))*Math.PI/b)}var b="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),d={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,
	.335],[.6,-.28,.735,.045],a],Out:[[.25,.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(b,c){return 1-a(1-b,c)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(b,c){return.5>b?a(2*b,c)/2:1-a(-2*b+2,c)/2}]},c={linear:y(.25,.25,.75,.75)},e={},l;for(l in d)e.type=l,d[e.type].forEach(function(a){return function(d,
	e){c["ease"+a.type+b[e]]=g.fnc(d)?d:y.apply($jscomp$this,d)}}(e)),e={type:e.type};return c}(),ia={css:function(a,b,d){return a.style[b]=d},attribute:function(a,b,d){return a.setAttribute(b,d)},object:function(a,b,d){return a[b]=d},transform:function(a,b,d,c,e){c[e]||(c[e]=[]);c[e].push(b+"("+d+")")}},q=[],z=0,ja=function(){function a(){z=requestAnimationFrame(b)}function b(b){var c=q.length;if(c){for(var d=0;d<c;)q[d]&&q[d].tick(b),d++;a()}else cancelAnimationFrame(z),z=0}return a}();n.version="2.0.2";
	n.speed=1;n.running=q;n.remove=function(a){a=M(a);for(var b=q.length;b--;)for(var d=q[b],c=d.animations,e=c.length;e--;)F(a,c[e].animatable.target)&&(c.splice(e,1),c.length||d.pause())};n.getValue=J;n.path=function(a,b){var d=g.str(a)?v(a)[0]:a,c=b||100;return function(a){return{el:d,property:a,totalLength:d.getTotalLength()*(c/100)}}};n.setDashoffset=function(a){var b=a.getTotalLength();a.setAttribute("stroke-dasharray",b);return b};n.bezier=y;n.easings=N;n.timeline=function(a){var b=n(a);b.pause();
	b.duration=0;b.add=function(a){b.children.forEach(function(a){a.began=!0;a.completed=!0});w(a).forEach(function(a){var c=b.duration,d=a.offset;a.autoplay=!1;a.offset=g.und(d)?c:K(d,c);b.seek(a.offset);a=n(a);a.duration>c&&(b.duration=a.duration);a.began=!0;b.children.push(a)});b.reset();b.seek(0);b.autoplay&&b.restart();return b};return b};n.random=function(a,b){return Math.floor(Math.random()*(b-a+1))+a};return n});

/***/ }),

/***/ "./src/components/Couple.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding: 4rem 2rem;\n  align-content: stretch;\n  ", ";\n"], ["\n  display: flex;\n  padding: 4rem 2rem;\n  align-content: stretch;\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    padding: 1rem 0;\n    padding-top: 500px;\n  "], ["\n    padding: 1rem 0;\n    padding-top: 500px;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  img {\n    width: 300px;\n  }\n  ", ";\n"], ["\n  flex: 1;\n  img {\n    width: 300px;\n  }\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    text-align: center;\n    left: 0; \n    right: 0;\n    img {\n      height: 400px;\n      width: auto;\n      margin: 0 auto;\n    }\n  "], ["\n    position: absolute;\n    top: 0;\n    text-align: center;\n    left: 0; \n    right: 0;\n    img {\n      height: 400px;\n      width: auto;\n      margin: 0 auto;\n    }\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ContentSection = __webpack_require__("./src/components/blocks/ContentSection.js");
	
	var _ContentSection2 = _interopRequireDefault(_ContentSection);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Button = __webpack_require__("./src/components/atoms/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Emphasis = __webpack_require__("./src/components/atoms/Emphasis.js");
	
	var _Emphasis2 = _interopRequireDefault(_Emphasis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CoupleSection = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.media.mobile(_templateObject2);
	});
	
	var CoupleImageWrapper = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.media.mobile(_templateObject4);
	});
	
	exports.default = function (_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      CoupleSection,
	      null,
	      _react2.default.createElement(
	        _Pad2.default,
	        { v: 5, h: 1, style: { flex: 1 } },
	        _react2.default.createElement(_Emphasis2.default, null),
	        _react2.default.createElement(_ContentSection2.default, {
	          padding: false,
	          bold: false,
	          titleText: content.maleTitle,
	          bodyText: [content.maleBody.maleBody]
	        })
	      ),
	      _react2.default.createElement(
	        CoupleImageWrapper,
	        null,
	        _react2.default.createElement("img", { src: content.coupleImage.responsiveResolution.src })
	      ),
	      _react2.default.createElement(
	        _Pad2.default,
	        { v: 5, h: 1, style: { flex: 1 } },
	        _react2.default.createElement(_Emphasis2.default, { align: "flex-end" }),
	        _react2.default.createElement(_ContentSection2.default, {
	          padding: false,
	          align: "right",
	          bold: false,
	          titleText: content.femaleTitle,
	          bodyText: [content.femaleBody.femaleBody]
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _typography.H3,
	      { align: "center", style: { width: "100%" } },
	      "Interested in clinical trials?"
	    ),
	    _react2.default.createElement(_Spacer2.default, { span: 0.5 }),
	    _react2.default.createElement(
	      _Flex2.default,
	      { justify: "center" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/trials", style: { textDecoration: "none" } },
	        _react2.default.createElement(
	          _Button2.default,
	          null,
	          "Learn more"
	        )
	      )
	    ),
	    _react2.default.createElement(_Spacer2.default, { span: 3 })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  border: 1px solid black;\n  height: 12.5rem;\n  width: 8.125rem;\n  ", ";\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], ["\n  position: relative;\n  border: 1px solid black;\n  height: 12.5rem;\n  width: 8.125rem;\n  ", ";\n  &:hover {\n    border: 1px solid ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["padding-top: 3rem;"], ["padding-top: 3rem;"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["padding-bottom: 3rem;"], ["padding-bottom: 3rem;"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: .5rem;\n  color: white;\n  font-size: 1rem;\n  text-align: center;\n  transition: opacity 300ms;\n  cursor: default;\n  &:hover {\n    opacity: 1;\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: .5rem;\n  color: white;\n  font-size: 1rem;\n  text-align: center;\n  transition: opacity 300ms;\n  cursor: default;\n  &:hover {\n    opacity: 1;\n    background-color: ", ";\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  width: 100%;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ecoCell = __webpack_require__("./assets/product/eco-cell.png");
	
	var _ecoCell2 = _interopRequireDefault(_ecoCell);
	
	var _happiness = __webpack_require__("./assets/product/happiness.png");
	
	var _happiness2 = _interopRequireDefault(_happiness);
	
	var _time = __webpack_require__("./assets/product/time.png");
	
	var _time2 = _interopRequireDefault(_time);
	
	var _stopwatch = __webpack_require__("./assets/product/stopwatch.png");
	
	var _stopwatch2 = _interopRequireDefault(_stopwatch);
	
	var _checkCircularButton = __webpack_require__("./assets/product/check-circular-button.png");
	
	var _checkCircularButton2 = _interopRequireDefault(_checkCircularButton);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var iconSourceMap = {
	  stopwatch: _stopwatch2.default,
	  time: _time2.default,
	  eco: _ecoCell2.default,
	  happy: _happiness2.default,
	  check: _checkCircularButton2.default
	};
	
	var Icon = _styledComponents2.default.div(_templateObject, (0, _utils.r)("margin", "1.5rem", ".5rem .75rem"), (0, _utils.getThemeColor)("teal"));
	
	var Image = _styledComponents2.default.img(_templateObject2);
	
	var Text = _styledComponents2.default.div(_templateObject3);
	
	var Description = _styledComponents2.default.div(_templateObject4, (0, _utils.getThemeColor)("teal"));
	
	var ImageAndText = _styledComponents2.default.div(_templateObject5);
	
	exports.default = function (_ref) {
	  var _ref$src = _ref.src,
	      src = _ref$src === undefined ? "" : _ref$src,
	      _ref$tag = _ref.tag,
	      tag = _ref$tag === undefined ? "" : _ref$tag,
	      _ref$description = _ref.description,
	      description = _ref$description === undefined ? "" : _ref$description;
	  return _react2.default.createElement(
	    Icon,
	    null,
	    _react2.default.createElement(
	      ImageAndText,
	      null,
	      _react2.default.createElement(Image, { src: iconSourceMap[src] }),
	      _react2.default.createElement(
	        Text,
	        null,
	        tag
	      )
	    ),
	    _react2.default.createElement(
	      Description,
	      null,
	      description
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/IconGrid.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding-top: 2rem;\n  ", ";\n"], ["\n  display: flex;\n  padding-top: 2rem;\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  "], ["\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Icon = __webpack_require__("./src/components/Icon.js");
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.div(_templateObject);
	
	var Grid = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.media.tablet(_templateObject3);
	});
	
	exports.default = function (_ref) {
	  var _ref$benefits = _ref.benefits,
	      benefits = _ref$benefits === undefined ? { list: [] } : _ref$benefits;
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(
	      _typography.H2,
	      null,
	      benefits.title
	    ),
	    _react2.default.createElement(
	      Grid,
	      null,
	      benefits.icons.map(function (benefit) {
	        return _react2.default.createElement(_Icon2.default, {
	          src: benefit.src,
	          tag: benefit.tag,
	          description: benefit.description
	        });
	      })
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Needle.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$animated = _ref.animated,
	      animated = _ref$animated === undefined ? true : _ref$animated,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? "white" : _ref$color;
	
	  var definitions = _react2.default.createElement(
	    "defs",
	    null,
	    _react2.default.createElement("path", {
	      d: "M17.8950018,137.22572 L17.8950018,137.22572 L17.8950018,137.22572 C18.2097513,137.182467 18.4999692,137.402559 18.5432217,137.717309 C18.5467881,137.743261 18.5485775,137.769428 18.5485775,137.795624 L18.5485775,218.35881 L18.5485775,218.35881 C18.5485775,218.731049 18.2468187,219.032807 17.8745803,219.032807 L17.8745803,219.032807 L17.8745803,219.032807 C17.502528,219.032807 17.2009199,218.731199 17.2009199,218.359147 C17.2009199,218.359035 17.20092,218.358923 17.20092,218.35881 L17.2410964,137.975251 L17.2410964,137.975251 C17.2412854,137.597161 17.5204318,137.277193 17.8950018,137.22572 Z",
	      id: "path-1"
	    }),
	    _react2.default.createElement(
	      "filter",
	      {
	        x: "-167.0%",
	        y: "-2.8%",
	        width: "434.0%",
	        height: "105.5%",
	        filterUnits: "objectBoundingBox",
	        id: "filter-2"
	      },
	      _react2.default.createElement("feGaussianBlur", {
	        stdDeviation: "1.5",
	        "in": "SourceAlpha",
	        result: "shadowBlurInner1"
	      }),
	      _react2.default.createElement("feOffset", {
	        dx: "0",
	        dy: "1",
	        "in": "shadowBlurInner1",
	        result: "shadowOffsetInner1"
	      }),
	      _react2.default.createElement("feComposite", {
	        "in": "shadowOffsetInner1",
	        in2: "SourceAlpha",
	        operator: "arithmetic",
	        k2: "-1",
	        k3: "1",
	        result: "shadowInnerInner1"
	      }),
	      _react2.default.createElement("feColorMatrix", {
	        values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
	        type: "matrix",
	        "in": "shadowInnerInner1"
	      })
	    ),
	    _react2.default.createElement("path", {
	      d: "M15.1368148,19.0475668 L15.1368148,31.4242522 C15.2345781,31.8424806 15.7959759,32.048066 16.8210082,32.0410084 C17.8460405,32.0339508 18.4074383,31.8283654 18.5052015,31.4242522 L18.5052015,19.0475668",
	      id: "path-3"
	    }),
	    _react2.default.createElement(
	      "filter",
	      {
	        x: "-37.1%",
	        y: "-9.6%",
	        width: "174.2%",
	        height: "119.2%",
	        filterUnits: "objectBoundingBox",
	        id: "filter-4"
	      },
	      _react2.default.createElement("feMorphology", {
	        radius: "1",
	        operator: "erode",
	        "in": "SourceAlpha",
	        result: "shadowSpreadInner1"
	      }),
	      _react2.default.createElement("feGaussianBlur", {
	        stdDeviation: "0.5",
	        "in": "shadowSpreadInner1",
	        result: "shadowBlurInner1"
	      }),
	      _react2.default.createElement("feOffset", {
	        dx: "0",
	        dy: "0",
	        "in": "shadowBlurInner1",
	        result: "shadowOffsetInner1"
	      }),
	      _react2.default.createElement("feComposite", {
	        "in": "shadowOffsetInner1",
	        in2: "SourceAlpha",
	        operator: "arithmetic",
	        k2: "-1",
	        k3: "1",
	        result: "shadowInnerInner1"
	      }),
	      _react2.default.createElement("feColorMatrix", {
	        values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.131085824 0",
	        type: "matrix",
	        "in": "shadowInnerInner1"
	      })
	    ),
	    _react2.default.createElement("path", {
	      d: "M0.181088314,2.5032175 L0.181088314,10.2216491 C5.2504985,11.5630767 11.0060301,12.2309189 17.4476832,12.2251758 C22.6184737,12.2205657 26.9319497,11.7893346 30.3881112,10.9314826 C30.9544084,10.7909223 31.7520669,10.5543111 32.7810868,10.2216491 L32.7810868,2.5032175 C27.9321019,1.02279741 22.8209674,0.282587359 17.4476832,0.282587359 C12.0743991,0.282587359 6.31886746,1.02279741 0.181088314,2.5032175 Z",
	      id: "path-5"
	    }),
	    _react2.default.createElement(
	      "filter",
	      {
	        x: "-4.6%",
	        y: "-12.6%",
	        width: "109.2%",
	        height: "125.1%",
	        filterUnits: "objectBoundingBox",
	        id: "filter-6"
	      },
	      _react2.default.createElement("feGaussianBlur", {
	        stdDeviation: "1",
	        "in": "SourceAlpha",
	        result: "shadowBlurInner1"
	      }),
	      _react2.default.createElement("feOffset", {
	        dx: "1",
	        dy: "1",
	        "in": "shadowBlurInner1",
	        result: "shadowOffsetInner1"
	      }),
	      _react2.default.createElement("feComposite", {
	        "in": "shadowOffsetInner1",
	        in2: "SourceAlpha",
	        operator: "arithmetic",
	        k2: "-1",
	        k3: "1",
	        result: "shadowInnerInner1"
	      }),
	      _react2.default.createElement("feColorMatrix", {
	        values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.361979167 0",
	        type: "matrix",
	        "in": "shadowInnerInner1"
	      })
	    ),
	    _react2.default.createElement(
	      "linearGradient",
	      { x1: "50%", y1: "0%", x2: "50%", y2: "100%", id: "linearGradient-7" },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0", offset: "35.2359694%" }),
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", offset: "100%" })
	    ),
	    _react2.default.createElement("polygon", {
	      id: "EchoVRPath",
	      points: "1.3473547 140.237636 33.9297055 140.153416 33.9297055 65.1299871 1.3473547 65.1299871"
	    }),
	    _react2.default.createElement("path", {
	      d: "M0,66.4041165 C4.3425681,65.4179358 9.84007025,64.924423 16.4925064,64.9235783 C23.1449426,64.9227335 28.5024321,65.4350254 32.564975,66.460454 L32.564975,69.4308377 C31.3144303,70.5276098 25.9569408,71.0463671 16.4925064,70.9871095 C7.02807204,70.9278518 1.5305699,70.3977156 0,69.3967008 L0,66.4041165 Z",
	      id: "path-9"
	    }),
	    _react2.default.createElement("path", {
	      d: "M12.3230282,-100.65255343 L20.6112047,-100.65255343 L20.6112047,66.9899975 C20.1575421,67.4405322 18.7761793,67.6688977 16.4671164,67.6750941 C14.1580536,67.6812906 12.7766908,67.452925 12.3230282,66.9899975 L12.3230282,1.65255343 Z",
	      id: "path-10"
	    }),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "50%",
	        y1: "95.7843703%",
	        x2: "50%",
	        y2: "83.1984116%",
	        id: "linearGradient-11"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0", offset: "0%" }),
	      _react2.default.createElement("stop", {
	        stopColor: "#FFFFFF",
	        stopOpacity: "0.516701212",
	        offset: "37.0926244%"
	      }),
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", offset: "100%" })
	    ),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "50%",
	        y1: "96.1019356%",
	        x2: "50%",
	        y2: "94.6900424%",
	        id: "linearGradient-12"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0", offset: "100%" })
	    ),
	    _react2.default.createElement("path", {
	      d: "M33.9582821,140.119291 L34.0241381,140.119291 L34.0241381,48.6087516 C30.3150076,49.9129 24.794024,50.5818371 17.4611873,50.6155629 C10.1283506,50.6492888 4.607367,49.9803517 0.898236465,48.6087516 L0.898236465,140.119291 L0.922378678,140.119291 C4.6924049,141.456198 10.2047254,142.116858 17.4593451,142.10127 C24.6896126,142.085734 30.1892583,141.425074 33.9582821,140.119291 Z",
	      id: "path-13"
	    }),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "13.7947182%",
	        y1: "50%",
	        x2: "0%",
	        y2: "50%",
	        id: "linearGradient-14"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#000000", offset: "100%" })
	    ),
	    _react2.default.createElement("path", {
	      d: "M33.1390757,91.9535204 L33.1864009,91.9535204 L33.1864009,0.44298124 C29.4704962,2.11070603 23.9394294,2.96143135 16.5932005,2.99515719 C9.2469715,3.02888303 3.71590468,2.17815771 0,0.44298124 L0,91.9535204 L0.0152553989,91.9535204 C3.82022659,93.9264875 9.35953598,94.9042129 16.6331836,94.8866966 C23.8884117,94.8692246 29.3903757,93.8914993 33.1390757,91.9535204 Z",
	      id: "path-15"
	    }),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "86.7973352%",
	        y1: "50%",
	        x2: "100%",
	        y2: "50%",
	        id: "linearGradient-16"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#000000", offset: "100%" })
	    ),
	    _react2.default.createElement("path", {
	      d: "M33.1390757,91.9535204 L33.1864009,91.9535204 L33.1864009,0.44298124 C29.4704962,2.11070603 23.9394294,2.96143135 16.5932005,2.99515719 C9.2469715,3.02888303 3.71590468,2.17815771 0,0.44298124 L0,91.9535204 L0.0152553989,91.9535204 C3.82022659,93.9264875 9.35953598,94.9042129 16.6331836,94.8866966 C23.8884117,94.8692246 29.3903757,93.8914993 33.1390757,91.9535204 Z",
	      id: "path-17"
	    })
	  );
	
	  return _react2.default.createElement(
	    "g",
	    { id: "Needle", transform: "translate(357.818912, -200.000000)" },
	    definitions,
	    _react2.default.createElement(
	      "g",
	      { id: "needleMetalTip" },
	      _react2.default.createElement("use", { fill: "#D8D8D8", fillRule: "evenodd", xlinkHref: "#path-1" }),
	      _react2.default.createElement("use", {
	        fill: "black",
	        fillOpacity: "1",
	        filter: "url(#filter-2)",
	        xlinkHref: "#path-1"
	      }),
	      _react2.default.createElement("path", {
	        stroke: "#979797",
	        strokeWidth: "0.5",
	        d: "M17.9290366,137.473392 C17.6781757,137.507865 17.4912229,137.722158 17.4910964,137.975376 L17.45092,218.358935 L17.4509199,218.359147 C17.4509199,218.593128 17.6405992,218.782807 17.8745803,218.782807 C18.1087475,218.782807 18.2985775,218.592977 18.2985775,218.35881 L18.2985775,137.795624 C18.2985775,137.780812 18.2975657,137.766018 18.2955492,137.751343 C18.2710937,137.57338 18.1070004,137.448937 17.9290366,137.473392 Z"
	      }),
	      _react2.default.createElement("use", {
	        strokeOpacity: "0.629161005",
	        stroke: "#979797",
	        strokeWidth: "0.5",
	        xlinkHref: "#path-1"
	      })
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "just-the-tip", transform: "translate(1.000000, 136.722008)" },
	      _react2.default.createElement(
	        "g",
	        { id: "MetalNeedleHolder" },
	        _react2.default.createElement("use", { fill: "#D8D8D8", fillRule: "evenodd", xlinkHref: "#path-3" }),
	        _react2.default.createElement("use", {
	          fill: "black",
	          fillOpacity: "1",
	          filter: "url(#filter-4)",
	          xlinkHref: "#path-3"
	        }),
	        _react2.default.createElement("use", { stroke: "#979797", strokeWidth: "0.5", xlinkHref: "#path-3" })
	      ),
	      _react2.default.createElement("path", {
	        d: "M13.464133,12.0421746 L13.464133,20.3952976 C14.0696996,20.623755 15.1898266,20.7458358 16.8245142,20.7615402 C18.4592017,20.7772445 19.5793287,20.6551636 20.1848953,20.3952976 L20.1848953,12.0421746",
	        id: "PlasticNeedleHolder",
	        fill: "#34495E"
	      }),
	      _react2.default.createElement(
	        "g",
	        { id: "plasticBase" },
	        _react2.default.createElement("use", { fill: "#34495E", fillRule: "evenodd", xlinkHref: "#path-5" }),
	        _react2.default.createElement("use", {
	          fill: "black",
	          fillOpacity: "1",
	          filter: "url(#filter-6)",
	          xlinkHref: "#path-5"
	        })
	      )
	    ),
	    _react2.default.createElement("path", {
	      d: "M0.898236465,48.8272423 C6.4031521,47.4800354 11.9080677,46.806432 17.4129834,46.806432 C22.917899,46.806432 28.4228146,47.4800354 33.9277303,48.8272423",
	      id: "TopOfNeedleBodyBack",
	      stroke: "#979797",
	      strokeWidth: "0.5"
	    }),
	    _react2.default.createElement(
	      "g",
	      { id: "EchoVR", opacity: "0.97509058" },
	      _react2.default.createElement("use", { fillOpacity: "0.469999999", fill: "#BBE2FF", xlinkHref: "#EchoVRPath" }),
	      _react2.default.createElement("use", {
	        fillOpacity: "0.87",
	        fill: "url(#linearGradient-7)",
	        xlinkHref: "#EchoVRPath"
	      })
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "plunger", transform: "translate(1.347355, 0.000000)" },
	      _react2.default.createElement(
	        "g",
	        { id: "plungerRound" },
	        _react2.default.createElement("use", { fill: "#4B4B4B", fillRule: "evenodd", xlinkHref: "#path-9" }),
	        _react2.default.createElement("path", {
	          stroke: "#484646",
	          strokeWidth: "0.5",
	          d: "M0.25,66.604206 L0.25,69.2561639 C1.8735209,70.1741777 7.3221241,70.679688 16.4940717,70.7371144 C25.6580507,70.7944908 30.9797239,70.3002725 32.314975,69.3113365 L32.314975,66.6557957 C28.2981712,65.6674592 23.0231732,65.172749 16.4925382,65.1735783 C9.95651726,65.1744083 4.54176627,65.6517328 0.25,66.6042125 Z"
	        })
	      ),
	      _react2.default.createElement(
	        "g",
	        { id: "plungerStick" },
	        _react2.default.createElement("use", { fill: "#4B4B4B", fillRule: "evenodd", xlinkHref: "#path-10" }),
	        _react2.default.createElement("path", {
	          stroke: "#FFFFFF",
	          strokeWidth: "0.5",
	          d: "M12.0730282,-100.40255343 L20.8612047,-100.40255343 L20.8612047,66.9899975 L20.7873688,67.1673847 C20.2669693,67.684196 18.8484475,67.9187047 16.4677873,67.9250932 C14.0858789,67.9314851 12.6655283,67.6966742 12.1444737,67.1649784 L12.0730282,66.9899975 L12.0730282,1.40255343 Z"
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "NeedleBody" },
	      _react2.default.createElement("use", {
	        fill: "url(#linearGradient-12)",
	        fillRule: "evenodd",
	        xlinkHref: "#path-13"
	      }),
	      _react2.default.createElement("path", {
	        stroke: "#979797",
	        strokeWidth: "0.5",
	        d: "M33.7741381,139.918207 L33.7741381,48.9583743 C30.0405998,50.1985133 24.6053178,50.8327077 17.4623371,50.8655603 C10.319778,50.898411 4.88374916,50.2663266 1.14823646,48.9641271 L1.14823646,139.933515 C4.88276827,141.22575 10.3215086,141.866606 17.4588079,141.85127 C24.5983722,141.835929 30.0386857,141.190049 33.7741384,139.918202 Z"
	      })
	    ),
	    _react2.default.createElement("path", {
	      d: "M0.898236465,139.702522 C6.4031521,138.383037 11.9080677,137.723295 17.4129834,137.723295 C22.917899,137.723295 28.4228146,138.383037 33.9277303,139.702522",
	      id: "needleBackLine",
	      stroke: "#979797",
	      strokeWidth: "0.5",
	      strokeDasharray: "2,1"
	    }),
	    _react2.default.createElement("path", {
	      d: "M16.1682564,139.923485 C16.30416,140.371764 16.7073152,140.592461 17.377722,140.585578 C18.0481287,140.578694 18.462396,140.367324 18.6205238,139.951469 C18.4727361,139.471953 18.0584688,139.229894 17.377722,139.225292 C16.6969751,139.22069 16.2938199,139.453421 16.1682564,139.923485 Z",
	      id: "needleEntrance",
	      stroke: "#979797",
	      strokeWidth: "0.5",
	      fill: "#D8D8D8",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }),
	    _react2.default.createElement(
	      "g",
	      {
	        id: "Measure-marks",
	        transform: "translate(6.736773, 80.649936)",
	        stroke: "#979797",
	        strokeWidth: "0.5",
	        strokeLinecap: "round"
	      },
	      _react2.default.createElement("path", {
	        d: "M0.062293333,47.2600729 C1.88893351,47.9254113 5.32439095,48.2580805 10.3686657,48.2580805 C15.4129404,48.2580805 18.8483978,47.9254113 20.675038,47.2600729",
	        id: "measureMark1"
	      }),
	      _react2.default.createElement("path", {
	        d: "M0.062293333,35.4529807 C1.88893351,36.118319 5.32439095,36.4509882 10.3686657,36.4509882 C15.4129404,36.4509882 18.8483978,36.118319 20.675038,35.4529807",
	        id: "measureMark2"
	      }),
	      _react2.default.createElement("path", {
	        d: "M0.062293333,23.6458884 C1.88893351,24.3112268 5.32439095,24.643896 10.3686657,24.643896 C15.4129404,24.643896 18.8483978,24.3112268 20.675038,23.6458884",
	        id: "measureMark3"
	      }),
	      _react2.default.createElement("path", {
	        d: "M0.062293333,11.8387962 C1.88893351,12.5041346 5.32439095,12.8368038 10.3686657,12.8368038 C15.4129404,12.8368038 18.8483978,12.5041346 20.675038,11.8387962",
	        id: "measureMark4"
	      }),
	      _react2.default.createElement("path", {
	        d: "M0.062293333,0.0317039396 C1.88893351,0.697042318 5.32439095,1.02971151 10.3686657,1.02971151 C15.4129404,1.02971151 18.8483978,0.697042318 20.675038,0.0317039396",
	        id: "measureMark5"
	      })
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "shadow", opacity: "0.1", transform: "translate(0.898236, 48.608752)" },
	      _react2.default.createElement(
	        "g",
	        { id: "left-shadow" },
	        _react2.default.createElement("use", {
	          fill: "url(#linearGradient-14)",
	          fillRule: "evenodd",
	          xlinkHref: "#path-15"
	        }),
	        _react2.default.createElement("path", {
	          stroke: "#979797",
	          strokeWidth: "0.5",
	          d: "M0.25,91.793003 C0.209918452,91.7726385 0.170030306,91.7521649 0.130335565,91.7315823 L0.0152553989,91.7035204 L0,91.7035204 L0,91.9535204 L0.25,91.9535204 L0.25,91.793003 Z M0.25,0.83057396 L0.25,0.44298124 L-0.105775807,0.669501611 C0.0110644858,0.72406128 0.129656366,0.777751983 0.25,0.83057396 Z M32.9364009,0.824526835 C33.0555762,0.774160317 33.1730311,0.723005881 33.2887658,0.671063313 L32.9364009,0.44298124 L32.9364009,0.824526835 Z M32.9364009,91.7765271 L32.9364009,91.9535204 L33.1864009,91.9535204 L33.1864009,91.7035204 L33.1390757,91.7035204 L33.0242669,91.7314418 C32.9950872,91.7465269 32.9657986,91.7615535 32.9364011,91.7765215 Z M32.9364011,91.7765215 C29.2306288,93.6633509 23.7947601,94.6194494 16.6325815,94.6366973 C9.47198139,94.6539414 4.01001068,93.7033796 0.25,91.793003 L0.25,0.83057396 C3.99763795,2.47551052 9.44407518,3.27798078 16.5943482,3.24515455 C23.7448894,3.2123271 29.1904832,2.40764746 32.9364009,0.824526835 L32.9364009,91.7765271 Z"
	        })
	      ),
	      _react2.default.createElement(
	        "g",
	        { id: "right-shadow" },
	        _react2.default.createElement("use", {
	          fill: "url(#linearGradient-16)",
	          fillRule: "evenodd",
	          xlinkHref: "#path-17"
	        }),
	        _react2.default.createElement("path", {
	          stroke: "#979797",
	          strokeWidth: "0.5",
	          d: "M32.9364009,91.7765271 L32.9364009,0.824526835 C29.1904832,2.40764746 23.7448894,3.2123271 16.5943482,3.24515455 C9.44407518,3.27798078 3.99763795,2.47551052 0.25,0.83057396 L0.25,91.793003 C4.01001068,93.7033796 9.47198139,94.6539414 16.6325815,94.6366973 C23.7947601,94.6194494 29.2306288,93.6633509 32.9364011,91.7765215 Z"
	        })
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/ProductAnimation.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animejs = __webpack_require__("./node_modules/animejs/anime.min.js");
	
	var _animejs2 = _interopRequireDefault(_animejs);
	
	var _Needle = __webpack_require__("./src/components/Needle.js");
	
	var _Needle2 = _interopRequireDefault(_Needle);
	
	var _VasDeference = __webpack_require__("./src/components/VasDeference.js");
	
	var _VasDeference2 = _interopRequireDefault(_VasDeference);
	
	var _VasDeferenceEchoVR = __webpack_require__("./src/components/VasDeferenceEchoVR.js");
	
	var _VasDeferenceEchoVR2 = _interopRequireDefault(_VasDeferenceEchoVR);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var timelineParameters = null;
	var _this = null;
	
	var animationStage1 = 0;
	var animationStage2 = 4300;
	var animationStage3 = 15500;
	var animationStage4 = 24500;
	
	var ProductAnimation = function (_React$Component) {
	  _inherits(ProductAnimation, _React$Component);
	
	  function ProductAnimation() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, ProductAnimation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this2), _this2.svgWidth = "561px", _this2.svgHeight = "330px", _this2.onResize = function () {
	      var width = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined ? window.innerWidth : 1200;
	      var svgWidth = width > 1050 ? "561px" : width > 832 ? "449px" : width > 650 ? "617px" : width > 449 ? "449px" : "393px";
	      var svgHeight = width > 1050 ? "330px" : width > 832 ? "264px" : width > 650 ? "363px" : width > 449 ? "264px" : "231px";
	      _this2.setState({ svgWidth: svgWidth, svgHeight: svgHeight });
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	  // stage = 1;
	
	  ProductAnimation.prototype.componentDidMount = function componentDidMount() {
	    _this = this;
	    _this.previousStage = 0;
	    var width = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined ? window.innerWidth : 1200;
	    this.svgWidth = width > 1050 ? "561px" : width > 832 ? "449px" : width > 650 ? "617px" : width > 449 ? "449px" : "393px";
	    this.svgHeight = width > 1050 ? "330px" : width > 832 ? "264px" : width > 650 ? "363px" : width > 449 ? "264px" : "231px";
	
	    var spermPath = _animejs2.default.path("#ProductAnimation #spermPath");
	    var spermPath2 = _animejs2.default.path("#ProductAnimation #spermPath2");
	    var echoVRPathVas = _animejs2.default.path("#ProductAnimation #echoVRFluid");
	
	    timelineParameters = _animejs2.default.timeline({
	      update: function update(anim) {
	        var currentTime = anim.duration * anim.progress / 100;
	        switch (_this.stage) {
	          case 1:
	            if (currentTime > animationStage2) {
	              anim.pause();
	              anim.seek(animationStage1);
	              anim.play();
	            }
	            break;
	          case 2:
	            if (currentTime > animationStage3) {
	              anim.pause();
	              anim.seek(animationStage2);
	              anim.play();
	            }
	            break;
	          case 3:
	            if (currentTime < animationStage3 || currentTime == anim.duration) {
	              anim.pause();
	              anim.seek(animationStage3);
	              anim.play();
	            }
	            break;
	          case 4:
	            if (currentTime < animationStage3 || currentTime == anim.duration) {
	              anim.pause();
	              anim.seek(animationStage3);
	              anim.play();
	            }
	            break;
	          default:
	            if (currentTime > animationStage2) anim.pause();
	            break;
	        }
	      }
	    });
	
	    var lowerNeedle = {
	      targets: "#ProductAnimation #Needle",
	      translateY: [-200, 0],
	      translateX: [360, 360],
	      easing: "easeOutQuad",
	      duration: 3000,
	      loop: false
	    };
	
	    var raiseNeedle = {
	      targets: "#ProductAnimation #Needle",
	      translateY: [0, -200],
	      translateX: [360, 360],
	      easing: "easeOutQuad",
	      duration: 3000,
	      delay: 1000,
	      loop: false
	    };
	
	    var lowerPlunger = {
	      targets: "#ProductAnimation #plunger",
	      translateY: [0, 65],
	      translateX: [1.347355, 1.347355],
	      easing: "linear",
	      duration: 4500,
	      loop: false
	    };
	
	    var lowerPlungerContents = {
	      targets: "#ProductAnimation #EchoVRPath",
	      points: [{
	        value: "1.3473547 140.237636 33.9297055 140.153416 33.9297055 140 1.3473547 140"
	      }],
	      easing: "linear",
	      offset: "-=4500",
	      duration: 4500,
	      loop: true
	    };
	
	    var scaleFluid = {
	      targets: "#ProductAnimation #echoVRFluid",
	      strokeDashoffset: [_animejs2.default.setDashoffset, 0],
	      easing: "easeInOutQuad",
	      duration: 4500,
	      offset: "-=4500",
	      loop: true
	    };
	
	    var showFluid = {
	      targets: "#ProductAnimation #echoVRFluid",
	      opacity: [0, 0.8],
	      easing: "easeOutQuad",
	      offset: "-=4500",
	      duration: 4500,
	      loop: true
	    };
	
	    var scaleFluidRightFace = {
	      targets: "#ProductAnimation #echoVRRightFace",
	      opacity: [0, 1],
	      easing: "easeInOutQuad",
	      duration: 1000,
	      offset: "-=4500",
	      loop: false
	    };
	
	    var scaleFluidLeftFace = {
	      targets: "#ProductAnimation #echoVRLeftFace",
	      translateX: echoVRPathVas("x"),
	      translateY: echoVRPathVas("y"),
	      easing: "easeInOutQuad",
	      duration: 4500,
	      offset: "-=4500",
	      loop: false
	    };
	
	    var showFluidLeftFace = {
	      targets: "#ProductAnimation #echoVRLeftFace",
	      opacity: [0, 1],
	      easing: "easeInOutQuad",
	      duration: 1500,
	      offset: "-=4500",
	      loop: false
	    };
	
	    var zoomInOnVas = {
	      targets: "#ProductAnimation",
	      scale: 2,
	      translateX: [0, -150],
	      translateY: [0, -150],
	      easing: "linear",
	      duration: 2500,
	      loop: false
	    };
	
	    var spermSwim = {
	      targets: "#ProductAnimation #sperm .nature",
	      translateX: spermPath("x"),
	      translateY: spermPath("y"),
	      rotate: spermPath("angle"),
	      easing: "linear",
	      scale: [0.35, 0.35],
	      duration: 3500,
	      loop: false,
	      delay: function delay(nature, i, l) {
	        return i * 150;
	      }
	    };
	
	    var spermSwim2 = {
	      targets: "#ProductAnimation #sperm .nature",
	      translateX: spermPath2("x"),
	      translateY: spermPath2("y"),
	      rotate: spermPath2("angle"),
	      easing: "easeOutCirc",
	      scale: [0.4, 0.3],
	      duration: 4000,
	      loop: false,
	      delay: function delay(nature, i, l) {
	        return i * 200;
	      }
	    };
	
	    var spermFade = {
	      targets: "#ProductAnimation #sperm .nature",
	      easing: "easeInQuad",
	      translateY: function translateY(nature, i, l) {
	        i++;
	        return "-=" + i + 1.5;
	      },
	      translateX: function translateX(nature, i, l) {
	        i++;
	        if (i % 2 == 0) return "-=20";
	        return "+=20";
	      },
	      rotate: "+=0",
	      scale: [0.3, 0.1],
	      opacity: [1, 0],
	      duration: 6000,
	      offset: "-=1000",
	      delay: function delay(nature, i, l) {
	        return i * 100;
	      },
	      loop: true
	    };
	
	    timelineParameters.add(spermSwim).add(lowerNeedle).add(lowerPlunger).add(lowerPlungerContents).add(scaleFluid).add(showFluid).add(showFluidLeftFace).add(scaleFluidLeftFace).add(scaleFluidRightFace).add(raiseNeedle).add(zoomInOnVas).add(spermSwim2).add(spermFade);
	
	    window.addEventListener("resize", this.onResize);
	  };
	
	  ProductAnimation.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    _this.previousStage = _this.stage;
	    _this.stage = nextProps.stage > 0 ? nextProps.stage : 1;
	    switch (nextProps.stage) {
	      case 1:
	        console.log("_this.previousStage");
	        console.log(_this.previousStage);
	        if (_this.previousStage != undefined || _this.previousStage != 0) {
	          timelineParameters.pause();
	          timelineParameters.seek(animationStage1);
	          timelineParameters.play();
	        }
	        break;
	      case 2:
	        timelineParameters.pause();
	        timelineParameters.seek(animationStage2);
	        timelineParameters.play();
	        break;
	      case 3:
	        timelineParameters.pause();
	        timelineParameters.seek(animationStage3);
	        timelineParameters.play();
	        break;
	      case 4:
	        timelineParameters.pause();
	        timelineParameters.seek(animationStage3);
	        timelineParameters.play();
	        break;
	      default:
	        timelineParameters.seek(animationStage1);
	    }
	  };
	
	  ProductAnimation.prototype.render = function render() {
	    var WhiteBackground = _react2.default.createElement(
	      "g",
	      { id: "whiteBG" },
	      _react2.default.createElement("rect", {
	        id: "bg-path-1",
	        x: "0",
	        y: "0.045045045",
	        width: "561",
	        height: "329.924067"
	      }),
	      _react2.default.createElement("use", {
	        fill: "#FFFFFF",
	        fillOpacity: "0",
	        fillRule: "evenodd",
	        xlinkHref: "#bg-path-1"
	      }),
	      _react2.default.createElement("rect", {
	        stroke: "#979797",
	        strokeWidth: "0.5",
	        x: "0.25",
	        y: "0.295045045",
	        width: "560.5",
	        height: "329.424067"
	      })
	    );
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "svg",
	        {
	          width: this.svgWidth,
	          height: this.svgHeight,
	          viewBox: "0 0 561 330",
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          display: "block",
	          preserveAspectRatio: "none"
	        },
	        _react2.default.createElement(
	          "g",
	          { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	          _react2.default.createElement(
	            "svg",
	            { width: "660px", height: "430px", viewBox: "40 40 561 330" },
	            _react2.default.createElement(
	              "g",
	              { id: "ProductAnimation" },
	              _react2.default.createElement(_VasDeference2.default, null),
	              _react2.default.createElement(_Needle2.default, null),
	              _react2.default.createElement(_VasDeferenceEchoVR2.default, null)
	            )
	          ),
	          WhiteBackground
	        )
	      )
	    );
	  };
	
	  return ProductAnimation;
	}(_react2.default.Component);
	
	exports.default = ProductAnimation;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/ProductAnimationMobile.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n"], ["\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  padding-top: 3rem;\n  max-width: 100%;\n"], ["\n  padding-top: 3rem;\n  max-width: 100%;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex-wrap: wrap;\n  max-width: 1200px;\n  padding: 2rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex-wrap: wrap;\n  max-width: 1200px;\n  padding: 2rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  padding: 3rem 2rem 3rem 1rem;\n  flex: 2;\n  ", ";\n"], ["\n  padding: 3rem 2rem 3rem 1rem;\n  flex: 2;\n  ", ";\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\npadding: 1rem 2rem 3rem 1rem;\n"], ["\npadding: 1rem 2rem 3rem 1rem;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  flex: 2;\n  width: 100%;\n"], ["\n  flex: 2;\n  width: 100%;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _reactWaypoint = __webpack_require__("./node_modules/react-waypoint/build/waypoint.js");
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _vasano_frame = __webpack_require__("./assets/animation/vasano_frame1.gif");
	
	var _vasano_frame2 = _interopRequireDefault(_vasano_frame);
	
	var _vasano_frame3 = __webpack_require__("./assets/animation/vasano_frame2.gif");
	
	var _vasano_frame4 = _interopRequireDefault(_vasano_frame3);
	
	var _vasano_frame5 = __webpack_require__("./assets/animation/vasano_frame3.gif");
	
	var _vasano_frame6 = _interopRequireDefault(_vasano_frame5);
	
	var _vasano_frame7 = __webpack_require__("./assets/animation/vasano_frame4.gif");
	
	var _vasano_frame8 = _interopRequireDefault(_vasano_frame7);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Title = _typography.H4.extend(_templateObject);
	
	var Grid = _styledComponents2.default.div(_templateObject2);
	
	var Image = _styledComponents2.default.img(_templateObject3);
	
	var AnimationContainer = _styledComponents2.default.div(_templateObject4);
	
	var AnimationText = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.theme.media.desktop(_templateObject6);
	});
	
	var AnimationSVG = _styledComponents2.default.div(_templateObject7);
	
	exports.default = function (_ref) {
	  var _ref$animationTitles = _ref.animationTitles,
	      animationTitles = _ref$animationTitles === undefined ? [""] : _ref$animationTitles,
	      _ref$animationDescrip = _ref.animationDescriptions,
	      animationDescriptions = _ref$animationDescrip === undefined ? [""] : _ref$animationDescrip;
	  return _react2.default.createElement(
	    Grid,
	    null,
	    _react2.default.createElement(
	      AnimationContainer,
	      null,
	      _react2.default.createElement(
	        AnimationSVG,
	        null,
	        " ",
	        _react2.default.createElement(Image, { style: { paddingTop: "0px" }, src: _vasano_frame2.default }),
	        " "
	      ),
	      _react2.default.createElement(
	        AnimationText,
	        null,
	        _react2.default.createElement(
	          Title,
	          null,
	          " ",
	          animationTitles[0],
	          " "
	        ),
	        _react2.default.createElement(
	          _typography.Description,
	          null,
	          " ",
	          animationDescriptions[0],
	          " "
	        )
	      ),
	      _react2.default.createElement(
	        AnimationSVG,
	        null,
	        " ",
	        _react2.default.createElement(Image, { src: _vasano_frame4.default }),
	        " "
	      ),
	      _react2.default.createElement(
	        AnimationText,
	        null,
	        _react2.default.createElement(
	          Title,
	          null,
	          " ",
	          animationTitles[1],
	          " "
	        ),
	        _react2.default.createElement(
	          _typography.Description,
	          null,
	          " ",
	          animationDescriptions[1],
	          " "
	        )
	      ),
	      _react2.default.createElement(
	        AnimationSVG,
	        null,
	        " ",
	        _react2.default.createElement(Image, { src: _vasano_frame6.default }),
	        " "
	      ),
	      _react2.default.createElement(
	        AnimationText,
	        null,
	        _react2.default.createElement(
	          Title,
	          null,
	          " ",
	          animationTitles[2],
	          " "
	        ),
	        _react2.default.createElement(
	          _typography.Description,
	          null,
	          " ",
	          animationDescriptions[2],
	          " "
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/ProductAnimationSlider.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: url(", ") repeat-y center top;\n  height: 100%;\n  width: 2px;\n  position: absolute;\n"], ["\n  background: url(", ") repeat-y center top;\n  height: 100%;\n  width: 2px;\n  position: absolute;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  transition: top 300ms, bottom: 300ms;\n  height: 50vh;\n  left: 2rem;\n  ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  transition: top 300ms, bottom: 300ms;\n  height: 50vh;\n  left: 2rem;\n  ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  z-index: 3;\n  border-radius: 50%;\n  height: ", ";\n  width: ", ";\n  background: ", ";\n  border: .25rem solid ", ";\n  border-width: ", ";\n"], ["\n  cursor: pointer;\n  z-index: 3;\n  border-radius: 50%;\n  height: ", ";\n  width: ", ";\n  background: ", ";\n  border: .25rem solid ", ";\n  border-width: ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  z-index: 3;\n  padding: .5rem 0;\n  background: ", ";\n  transform: ", ";\n  transition: transform 500ms;\n"], ["\n  z-index: 3;\n  padding: .5rem 0;\n  background: ", ";\n  transform: ", ";\n  transition: transform 500ms;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  position: ", ";\n  top: ", ";\n  bottom: ", ";\n  transform: translate3d(0, ", ", 0);\n  transition: transform 0ms;\n  z-index: -10;\n  ", ";\n"], ["\n  position: ", ";\n  top: ", ";\n  bottom: ", ";\n  transform: translate3d(0, ", ", 0);\n  transition: transform 0ms;\n  z-index: -10;\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    transform: translate3d(0, ", ", 0);\n  "], ["\n    transform: translate3d(0, ", ", 0);\n  "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  flex-wrap: wrap-reverse;\n  max-width: 1200px;\n  padding: 3rem;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  flex-wrap: wrap-reverse;\n  max-width: 1200px;\n  padding: 3rem;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  padding: 3rem 2rem 3rem 1rem;\n  min-width: 15rem;\n  order: 1;\n  flex: 3;\n  ", ";\n"], ["\n  padding: 3rem 2rem 3rem 1rem;\n  min-width: 15rem;\n  order: 1;\n  flex: 3;\n  ", ";\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\npadding: 1rem 2rem 3rem 1rem;\n"], ["\npadding: 1rem 2rem 3rem 1rem;\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  order: 2;\n  flex: 2;\n"], ["\n  order: 2;\n  flex: 2;\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  height: 140vh;\n  position: relative;\n  margin-bottom: 45vh;\n"], ["\n  height: 140vh;\n  position: relative;\n  margin-bottom: 45vh;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _dashed = __webpack_require__("./assets/dashed.png");
	
	var _dashed2 = _interopRequireDefault(_dashed);
	
	var _reactWaypoint = __webpack_require__("./node_modules/react-waypoint/build/waypoint.js");
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _ProductAnimation = __webpack_require__("./src/components/ProductAnimation.js");
	
	var _ProductAnimation2 = _interopRequireDefault(_ProductAnimation);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Grid = _styledComponents2.default.div(_templateObject);
	
	var DottedLine = _styledComponents2.default.div(_templateObject2, _dashed2.default);
	
	var getDootPositioning = function getDootPositioning(_ref) {
	  var stage = _ref.stage;
	
	  if (stage === 0) return "\n      position: absolute;\n      top: -3vh;\n      bottom: auto; \n  ";
	  if (stage > 3) return "\n      position: absolute;\n      bottom: -32vh;\n      top: auto; \n  ";
	  return "\n      position: fixed;\n      bottom: 20vh;\n      top: 22vh; \n  ";
	};
	
	var Doots = _styledComponents2.default.div(_templateObject3, function (props) {
	  return getDootPositioning(props);
	});
	
	var Doot = _styledComponents2.default.div(_templateObject4, function (_ref2) {
	  var active = _ref2.active;
	  return active ? "1.25rem" : ".625rem";
	}, function (_ref3) {
	  var active = _ref3.active;
	  return active ? "1.25rem" : ".625rem";
	}, function (_ref4) {
	  var active = _ref4.active;
	  return active ? "black" : "white";
	}, (0, _utils.getThemeColor)("teal"), function (_ref5) {
	  var active = _ref5.active;
	  return active ? ".25rem" : ".0625rem";
	});
	
	var DootWrapper = _styledComponents2.default.div(_templateObject5, function (_ref6) {
	  var active = _ref6.active;
	  return active ? "none" : "none";
	}, function (_ref7) {
	  var active = _ref7.active,
	      stage = _ref7.stage,
	      index = _ref7.index;
	  return active ? "scale(2) translateY(0)" : "scale(1) translateY(" + (index - stage) + "rem)";
	});
	
	var ProductSlider = _styledComponents2.default.div(_templateObject6, function (_ref8) {
	  var stage = _ref8.stage;
	  return stage > 0 && stage < 4 ? "fixed" : "absolute";
	}, function (_ref9) {
	  var stage = _ref9.stage;
	  return stage < 4 ? "0vh" : "auto";
	}, function (_ref10) {
	  var stage = _ref10.stage;
	  return stage < 4 ? "auto" : "-5vh";
	}, function (_ref11) {
	  var stage = _ref11.stage;
	  return stage < 1 ? 0 : "25vh";
	}, function (props) {
	  return props.theme.media.mobile(_templateObject7, function (_ref12) {
	    var stage = _ref12.stage;
	    return stage < 1 ? 0 : "5vh";
	  });
	});
	
	var AnimationContainer = _styledComponents2.default.div(_templateObject8);
	
	var AnimationText = _styledComponents2.default.div(_templateObject9, function (props) {
	  return props.theme.media.desktop(_templateObject10);
	});
	
	var AnimationSVG = _styledComponents2.default.div(_templateObject11);
	
	var ProductTracks = _styledComponents2.default.div(_templateObject12);
	
	var StageWaypoint = function StageWaypoint(_ref13) {
	  var stage = _ref13.stage,
	      onStageChange = _ref13.onStageChange,
	      position = _ref13.position;
	  return _react2.default.createElement(
	    _reactWaypoint2.default,
	    {
	      onPositionChange: function onPositionChange(_ref14) {
	        var currentPosition = _ref14.currentPosition,
	            previousPosition = _ref14.previousPosition;
	
	        var slider = document.getElementById("productSlider");
	        var doots = document.getElementById("dootsInSlider");
	        if (currentPosition === "inside" && previousPosition === "above") {
	          onStageChange(stage);
	          if (stage == 0) {
	            slider.style.position = "relative";
	            slider.style.transform = "translate3d(0,0,0)";
	            doots.style.position = "absolute";
	            doots.style.top = "-3vh";
	            doots.style.bottom = "auto";
	          } else {
	            slider.style.position = "";
	            slider.style.transform = "";
	            doots.style.position = "";
	            doots.style.top = "";
	            doots.style.bottom = "";
	          }
	        }
	        if (currentPosition === "above") {
	          onStageChange(stage + 1);
	          slider.style.position = "";
	          slider.style.transform = "";
	          doots.style.position = "";
	          doots.style.top = "";
	          doots.style.bottom = "";
	        }
	      }
	    },
	    _react2.default.createElement("div", {
	      className: "stage-" + stage,
	      id: "stage-" + stage,
	      style: {
	        position: "absolute",
	        top: position
	      }
	    })
	  );
	};
	
	var Animation = function Animation(_ref15) {
	  var stage = _ref15.stage,
	      onStageChange = _ref15.onStageChange,
	      _ref15$animationTitle = _ref15.animationTitles,
	      animationTitles = _ref15$animationTitle === undefined ? [""] : _ref15$animationTitle,
	      _ref15$animationDescr = _ref15.animationDescriptions,
	      animationDescriptions = _ref15$animationDescr === undefined ? [""] : _ref15$animationDescr;
	
	  var dootStage = Math.max(1, Math.min(stage, 3));
	
	  return _react2.default.createElement(
	    ProductTracks,
	    null,
	    _react2.default.createElement(StageWaypoint, { stage: 0, position: "-25vh", onStageChange: onStageChange }),
	    _react2.default.createElement(StageWaypoint, { stage: 1, position: "20vh", onStageChange: onStageChange }),
	    _react2.default.createElement(StageWaypoint, { stage: 2, position: "60vh", onStageChange: onStageChange }),
	    _react2.default.createElement(StageWaypoint, { stage: 3, position: "100vh", onStageChange: onStageChange }),
	    _react2.default.createElement(
	      Grid,
	      null,
	      _react2.default.createElement(
	        ProductSlider,
	        { stage: stage, id: "productSlider" },
	        _react2.default.createElement(
	          AnimationContainer,
	          null,
	          _react2.default.createElement(
	            AnimationText,
	            null,
	            _react2.default.createElement(
	              _typography.H3,
	              null,
	              stage == 0 ? animationTitles[0] : stage < 3 ? animationTitles[stage - 1] : animationTitles[2]
	            ),
	            _react2.default.createElement(
	              _typography.Description,
	              null,
	              stage == 0 ? animationDescriptions[0] : stage < 3 ? animationDescriptions[stage - 1] : animationDescriptions[2]
	            )
	          ),
	          _react2.default.createElement(
	            AnimationSVG,
	            null,
	            _react2.default.createElement(_ProductAnimation2.default, { stage: stage })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Doots,
	        { id: "dootsInSlider", stage: stage },
	        _react2.default.createElement(DottedLine, null),
	        " ",
	        " ",
	        [1, 2, 3].map(function (index) {
	          return _react2.default.createElement(
	            DootWrapper,
	            {
	              active: index === dootStage,
	              stage: dootStage,
	              index: index
	            },
	            _react2.default.createElement(Doot, {
	              stage: dootStage,
	              index: index,
	              onClick: function onClick() {
	                return document.getElementById("stage-" + index).scrollIntoView(true);
	              }
	            })
	          );
	        })
	      )
	    )
	  );
	};
	
	var ProductAnimationSlider = function ProductAnimationSlider(_ref16) {
	  var _ref16$animationTitle = _ref16.animationTitles,
	      animationTitles = _ref16$animationTitle === undefined ? [""] : _ref16$animationTitle,
	      _ref16$animationDescr = _ref16.animationDescriptions,
	      animationDescriptions = _ref16$animationDescr === undefined ? [""] : _ref16$animationDescr,
	      _ref16$stage = _ref16.stage,
	      stage = _ref16$stage === undefined ? 0 : _ref16$stage,
	      onStageChange = _ref16.onStageChange,
	      titleForFrame = _ref16.titleForFrame,
	      props = _objectWithoutProperties(_ref16, ["animationTitles", "animationDescriptions", "stage", "onStageChange", "titleForFrame"]);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(Animation, {
	      stage: stage,
	      onStageChange: onStageChange,
	      animationTitles: animationTitles,
	      animationDescriptions: animationDescriptions
	    })
	  );
	};
	
	exports.default = (0, _recompose.withState)("stage", "onStageChange", 0)(ProductAnimationSlider);
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/VasDeference.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Sperm = __webpack_require__("./src/components/atoms/Sperm.js");
	
	var _Sperm2 = _interopRequireDefault(_Sperm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var vasDeferenceDefinitions = _react2.default.createElement(
	    "defs",
	    null,
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "10.3540532%",
	        y1: "6.28210663%",
	        x2: "50%",
	        y2: "100%",
	        id: "linearGradient-1"
	      },
	      _react2.default.createElement("stop", { stopColor: "#83DBD7", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#43BCB6", offset: "100%" })
	    ),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "50%",
	        y1: "0%",
	        x2: "50%",
	        y2: "57.8981983%",
	        id: "linearGradient-2"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0", offset: "0%" }),
	      _react2.default.createElement("stop", {
	        stopColor: "#FFFFFF",
	        stopOpacity: "0.883071588",
	        offset: "44.0369898%"
	      }),
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", offset: "60.674426%" })
	    ),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "48.4825615%",
	        y1: "6.26168736%",
	        x2: "50%",
	        y2: "47.929364%",
	        id: "linearGradient-3"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0", offset: "0%" }),
	      _react2.default.createElement("stop", {
	        stopColor: "#FFFFFF",
	        stopOpacity: "0.883071588",
	        offset: "64.2598055%"
	      }),
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", offset: "100%" })
	    )
	  );
	
	  var Sperm = function Sperm(_ref) {
	    var _ref$xOffset = _ref.xOffset,
	        xOffset = _ref$xOffset === undefined ? "0" : _ref$xOffset,
	        _ref$yOffset = _ref.yOffset,
	        yOffset = _ref$yOffset === undefined ? "-40" : _ref$yOffset;
	    return _react2.default.createElement(
	      "g",
	      { className: "nature", id: new Date().getTime() },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(" + xOffset + "," + yOffset + ") rotate(40.0)" },
	        _react2.default.createElement(
	          "path",
	          {
	            d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	            id: "tail",
	            stroke: "#FFFFFF",
	            strokeWidth: "3",
	            strokeLinecap: "round"
	          },
	          _react2.default.createElement("animate", {
	            dur: "0.35s",
	            repeatCount: "indefinite",
	            attributeName: "d",
	            values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	          })
	        ),
	        _react2.default.createElement("ellipse", {
	          id: "Oval",
	          fill: "#FFFFFF",
	          transform: "translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) ",
	          cx: "40.501453",
	          cy: "14.2376084",
	          rx: "8",
	          ry: "11.8646142"
	        })
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    "g",
	    {
	      id: "Vast-Deference",
	      transform: "translate(286.004906, 188.406295) scale(-1, 1) rotate(90.000000) translate(-286.004906, -188.406295) translate(120.857716, -81.190230)"
	    },
	    vasDeferenceDefinitions,
	    _react2.default.createElement("path", {
	      d: "M186.458548,20.9211764 C-11.854452,108.097124 14.4068331,258.68583 265.242403,472.687294 L267.707442,466.431581 L275.108051,453.154981 C44.8527432,261.577406 17.2825824,124.89063 192.397569,43.0946512",
	      id: "vasOutline",
	      stroke: "#979797",
	      strokeWidth: "2.5",
	      fill: "url(#linearGradient-1)",
	      transform: "translate(165.112302, 246.804235) scale(-1, 1) rotate(15.000000) translate(-165.112302, -246.804235) "
	    }),
	    _react2.default.createElement("path", {
	      d: "M87.292472,46.0629345 C188.983214,63.3302528 242.121631,108.161613 246.707723,180.557016 C254.513004,303.770081 108.282629,499.792348 107.528299,498.385442",
	      id: "spermPath",
	      stroke: "#FFFFFF",
	      strokeWidth: "0"
	    }),
	    _react2.default.createElement("path", {
	      d: "M87.292472,46.0629345 C170.539825,64.1781679 220.144185,93.0588782 236.105551,132.705065 C250.681955,168.911167 250.681955,205.802562 236,261",
	      id: "spermPath2",
	      stroke: "#FFFFFF",
	      strokeWidth: "0"
	    }),
	    " ",
	    _react2.default.createElement(
	      "g",
	      { id: "fluid" },
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -35) rotate(40.0)", fill: "none" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -43) rotate(40.0)", fill: "none" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -35) rotate(40.0)", fill: "none" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -43) rotate(40.0)", fill: "none" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -33) rotate(40.0)", fill: "none" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -43) rotate(40.0)", fill: "none" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -33) rotate(40.0)", fill: "34495E" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "fluid" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -43) rotate(40.0)", fill: "none" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#34495E",
	              strokeOpacity: "0.5",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "1s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "sperm", transform: "", stroke: "#FFFFFF", fill: "#FFFFFF" },
	      _react2.default.createElement(
	        "g",
	        { className: "nature" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -40) rotate(40.0)" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#FFFFFF",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "0.35s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          ),
	          _react2.default.createElement("ellipse", {
	            id: "Oval",
	            fill: "#FFFFFF",
	            transform: "translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) ",
	            cx: "40.501453",
	            cy: "14.2376084",
	            rx: "8",
	            ry: "11.8646142"
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "nature" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -25) rotate(40.0)" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#FFFFFF",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "0.35s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          ),
	          _react2.default.createElement("ellipse", {
	            id: "Oval",
	            fill: "#FFFFFF",
	            transform: "translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) ",
	            cx: "40.501453",
	            cy: "14.2376084",
	            rx: "8",
	            ry: "11.8646142"
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "nature" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -45) rotate(40.0)" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#FFFFFF",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "0.35s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          ),
	          _react2.default.createElement("ellipse", {
	            id: "Oval",
	            fill: "#FFFFFF",
	            transform: "translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) ",
	            cx: "40.501453",
	            cy: "14.2376084",
	            rx: "8",
	            ry: "11.8646142"
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "nature" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -35) rotate(40.0)" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#FFFFFF",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "0.35s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          ),
	          _react2.default.createElement("ellipse", {
	            id: "Oval",
	            fill: "#FFFFFF",
	            transform: "translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) ",
	            cx: "40.501453",
	            cy: "14.2376084",
	            rx: "8",
	            ry: "11.8646142"
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "nature" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -50) rotate(40.0)" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#FFFFFF",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "0.35s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          ),
	          _react2.default.createElement("ellipse", {
	            id: "Oval",
	            fill: "#FFFFFF",
	            transform: "translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) ",
	            cx: "40.501453",
	            cy: "14.2376084",
	            rx: "8",
	            ry: "11.8646142"
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "nature" },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0, -40) rotate(40.0)" },
	          _react2.default.createElement(
	            "path",
	            {
	              d: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
	              id: "tail",
	              stroke: "#FFFFFF",
	              strokeWidth: "3",
	              strokeLinecap: "round"
	            },
	            _react2.default.createElement("animate", {
	              dur: "0.35s",
	              repeatCount: "indefinite",
	              attributeName: "d",
	              values: "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5; M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1; M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4; M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9; M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5;"
	            })
	          ),
	          _react2.default.createElement("ellipse", {
	            id: "Oval",
	            fill: "#FFFFFF",
	            transform: "translate(40.501453, 14.237608) rotate(45.0) translate(-40.501453, -14.237608) ",
	            cx: "40.501453",
	            cy: "14.2376084",
	            rx: "8",
	            ry: "11.8646142"
	          })
	        )
	      )
	    ),
	    _react2.default.createElement("path", {
	      d: "M76.5571517,436.676448 L145.63425,436.676448 L145.63425,499.652896 C138.263356,518.154835 131.192031,527.405804 124.420275,527.405804 C117.64852,527.405804 101.694146,518.154835 76.5571517,499.652896 L76.5571517,436.676448 Z",
	      id: "fadeVasRight",
	      fill: "url(#linearGradient-2)",
	      transform: "translate(111.095701, 482.041126) rotate(43.000000) translate(-111.095701, -482.041126) "
	    }),
	    _react2.default.createElement("path", {
	      d: "M80.3964834,7.99263106 C92.6585895,-0.455032109 110.029434,2.26090642 132.509018,16.1404467 L116.289635,88.7007084 C106.922005,96.3980018 96.9853349,99.2646965 86.4796247,97.3007924 C75.9739146,95.3368883 68.6636719,83.8899 64.5488966,62.9598276 C64.7226867,33.4738271 70.0052156,15.1514282 80.3964834,7.99263106 Z",
	      id: "fadeVasLeft",
	      fill: "url(#linearGradient-3)",
	      transform: "translate(98.528957, 50.548948) rotate(103.000000) translate(-98.528957, -50.548948) "
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/VasDeferenceEchoVR.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var echoVRDefinitions = _react2.default.createElement(
	    "defs",
	    null,
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "56.908771%",
	        y1: "47.2480464%",
	        x2: "50%",
	        y2: "50%",
	        id: "echovr-linearGradient-1"
	      },
	      _react2.default.createElement("stop", { stopColor: "#BBE3FC", stopOpacity: "0.9", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#CCE9FD", stopOpacity: "0.77", offset: "64.973294%" }),
	      _react2.default.createElement("stop", { stopColor: "#BBE1FC", stopOpacity: "0.579766757", offset: "100%" })
	    ),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "44.8382772%",
	        y1: "55.2896649%",
	        x2: "-7.14014459%",
	        y2: "60.04325%",
	        id: "echovr-linearGradient-2"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0.65", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#000000", stopOpacity: "0.108808877", offset: "100%" })
	    ),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "100%",
	        y1: "47.7666498%",
	        x2: "0%",
	        y2: "39.6748353%",
	        id: "echovr-linearGradient-3"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FEFEFE", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#A5CFE4", offset: "100%" })
	    ),
	    _react2.default.createElement("path", {
	      d: "M88.4715245,1.11524836 C87.3990525,1.73416214 85.7654758,3.8546965 89.2193438,10.1399366 C92.6732119,16.4251768 94.8101284,17.0997195 95.8497753,16.5449976 C96.8894223,15.9902757 101.868082,15.0832797 97.0389946,6.153183 C92.2099067,-2.77691367 89.5439965,0.496334578 88.4715245,1.11524836 Z",
	      id: "echovr-path-4"
	    }),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "50%",
	        y1: "100%",
	        x2: "50%",
	        y2: "3.061617e-15%",
	        id: "echovr-linearGradient-5"
	      },
	      _react2.default.createElement("stop", { stopColor: "#F0F8FC", stopOpacity: "0.94", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#BBE1FE", stopOpacity: "0.82", offset: "100%" })
	    ),
	    _react2.default.createElement(
	      "linearGradient",
	      {
	        x1: "44.8382772%",
	        y1: "55.2896649%",
	        x2: "-61.7672471%",
	        y2: "62.4380296%",
	        id: "echovr-linearGradient-6"
	      },
	      _react2.default.createElement("stop", { stopColor: "#FFFFFF", stopOpacity: "0.62", offset: "0%" }),
	      _react2.default.createElement("stop", { stopColor: "#000000", stopOpacity: "0.108808877", offset: "100%" })
	    ),
	    _react2.default.createElement("path", {
	      d: "M1.78735826,38.6133113 C0.253606922,39.0953149 -0.538293355,41.1052178 1.41764042,47.9703581 C3.3735742,54.8354984 5.39771544,55.560642 6.60107369,55.2543505 C7.80443194,54.9480589 10.2357212,53.2364714 8.06512896,45.771463 C5.89453674,38.3064547 3.3211096,38.1313078 1.78735826,38.6133113 Z",
	      id: "echovr-path-7"
	    })
	  );
	
	  var echoVR = _react2.default.createElement(
	    "g",
	    { id: "EchoVR_Vas", transform: "translate(286.755575, 208.312741)" },
	    echoVRDefinitions,
	    _react2.default.createElement(
	      "g",
	      { id: "echoVRRightFace", style: { opacity: 0 } },
	      _react2.default.createElement("use", { fill: "url(#echovr-linearGradient-1)", xlinkHref: "#echovr-path-4" }),
	      _react2.default.createElement("use", {
	        stroke: "url(#echovr-linearGradient-3)",
	        strokeWidth: "0.5",
	        fillOpacity: "0.19",
	        fill: "url(#echovr-linearGradient-2)",
	        xlinkHref: "#echovr-path-4"
	      })
	    ),
	    _react2.default.createElement("path", {
	      d: "M93.6525137,8.01029601 C81.4920374,14.5798818 67.8153494,21.3567684 52.6224499,28.3409556 C37.4295504,35.3251429 21.2232565,41.5857351 4.00356824,47.1227324",
	      id: "echoVRFluid",
	      stroke: "url(#echovr-linearGradient-5)",
	      strokeWidth: "17.5",
	      style: { strokeDashoffset: "-97.9504px" }
	    }),
	    _react2.default.createElement(
	      "g",
	      { id: "echoVRLeftFace", style: { opacity: 0 } },
	      _react2.default.createElement(
	        "g",
	        {
	          style: {
	            transform: "translateX(-4.5px) translateY(-46.5px)"
	          }
	        },
	        _react2.default.createElement("use", { fill: "#ACDDF6", xlinkHref: "#echovr-path-7" }),
	        _react2.default.createElement("use", {
	          stroke: "url(#echovr-linearGradient-3)",
	          strokeWidth: "0.5",
	          fillOpacity: "0.390000015",
	          fill: "url(#echovr-linearGradient-6)",
	          xlinkHref: "#echovr-path-7"
	        })
	      )
	    )
	  );
	
	  return _react2.default.createElement(
	    "svg",
	    null,
	    echoVR
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/atoms/Sperm.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__("./src/styles/theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// First and Last path is repeated to allow smooth transitions
	var SpermTailPaths = ["M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 \
	  19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,\
	  41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5", "M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 \
	  19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,\
	  47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1", "M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,\
	  33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,\
	  46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4", "M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 \
	  24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,\
	  41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9", "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 \
	  19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,\
	  41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"];
	
	exports.default = function (_ref) {
	  var _ref$animated = _ref.animated,
	      animated = _ref$animated === undefined ? true : _ref$animated,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? "white" : _ref$color;
	
	  var animation = _react2.default.createElement("animate", {
	    dur: "0.6s",
	    repeatCount: "indefinite",
	    attributeName: "d",
	    values: SpermTailPaths.join(";")
	  });
	
	  var SpermTail = _react2.default.createElement(
	    "path",
	    {
	      d: SpermTailPaths[0],
	      stroke: _theme2.default.colors[color],
	      strokeWidth: "3",
	      strokeLinecap: "round"
	    },
	    animated && animation
	  );
	
	  var SpermHead = _react2.default.createElement("ellipse", {
	    fill: _theme2.default.colors[color],
	    transform: "translate(40.501453, 14.237608) rotate(45) translate(-40.501453, -14.237608) ",
	    cx: "40.501453",
	    cy: "14.2376084",
	    rx: "8",
	    ry: "11.8646142"
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: "sperm" },
	    _react2.default.createElement(
	      "svg",
	      {
	        width: "80px",
	        height: "25px",
	        viewBox: "0 0 80 25",
	        version: "1.1",
	        xmlns: "http://www.w3.org/2000/svg"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", transform: "translate(37, -30) rotate(45)" },
	        SpermHead,
	        SpermTail
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/opt/build/repo/node_modules/babel-preset-react-app/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/react-hot-loader/babel.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/product.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: ", ";\n  top: ", ";\n  bottom: ", ";\n  left: 0;\n  right: 0;\n  transform: translate3d(0, ", ", 0);\n  transition: transform 500ms;\n"], ["\n  position: ", ";\n  top: ", ";\n  bottom: ", ";\n  left: 0;\n  right: 0;\n  transform: translate3d(0, ", ", 0);\n  transition: transform 500ms;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 5rem 0rem;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  flex-wrap: wrap-reverse;\n  height: 170vh;\n"], ["\n  padding: 5rem 0rem;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  flex-wrap: wrap-reverse;\n  height: 170vh;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 3rem 1rem;\n  min-width: 15rem;\n  order: 1;\n  flex: 3;\n"], ["\n  padding: 3rem 1rem;\n  min-width: 15rem;\n  order: 1;\n  flex: 3;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  order: 2;\n  flex: 2;\n"], ["\n  order: 2;\n  flex: 2;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["font-size: 1.35rem;"], ["font-size: 1.35rem;"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Couple = __webpack_require__("./src/components/Couple.js");
	
	var _Couple2 = _interopRequireDefault(_Couple);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _ContentSection = __webpack_require__("./src/components/blocks/ContentSection.js");
	
	var _ContentSection2 = _interopRequireDefault(_ContentSection);
	
	var _IconGrid = __webpack_require__("./src/components/IconGrid.js");
	
	var _IconGrid2 = _interopRequireDefault(_IconGrid);
	
	var _Emphasis = __webpack_require__("./src/components/atoms/Emphasis.js");
	
	var _Emphasis2 = _interopRequireDefault(_Emphasis);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	var _ProductAnimationSlider = __webpack_require__("./src/components/ProductAnimationSlider.js");
	
	var _ProductAnimationSlider2 = _interopRequireDefault(_ProductAnimationSlider);
	
	var _ProductAnimationMobile = __webpack_require__("./src/components/ProductAnimationMobile.js");
	
	var _ProductAnimationMobile2 = _interopRequireDefault(_ProductAnimationMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var AnimationSlider = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var stage = _ref.stage;
	  return stage < 3 ? "fixed" : "absolute";
	}, function (_ref2) {
	  var stage = _ref2.stage;
	  return stage < 3 ? "20vh" : "auto";
	}, function (_ref3) {
	  var stage = _ref3.stage;
	  return stage < 3 ? "auto" : "0";
	}, function (_ref4) {
	  var stage = _ref4.stage;
	  return stage < 2 ? 0 : "-6vh";
	});
	
	var AnimationContainer = _styledComponents2.default.div(_templateObject2);
	
	var AnimationText = _styledComponents2.default.div(_templateObject3);
	
	var AnimationSVG = _styledComponents2.default.div(_templateObject4);
	
	var BodyText = _typography.P.extend(_templateObject5);
	
	var ProductPage = function (_React$Component) {
	  _inherits(ProductPage, _React$Component);
	
	  function ProductPage() {
	    _classCallCheck(this, ProductPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProductPage.prototype.componentWillMount = function componentWillMount() {
	    this.setState(_extends({}, this.state, {
	      waypointLocation: 0
	    }));
	  };
	
	  ProductPage.prototype.render = function render() {
	    var content = (0, _selectors.getGraphNode)(this.props.data, "ProductPage");
	    var missionContent = (0, _selectors.getGraphNode)(this.props.data, "MissionPage");
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: "Contraline Product",
	          meta: [{
	            name: "Contraline",
	            content: "Product"
	          }]
	        },
	        _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	      ),
	      _react2.default.createElement(_NavBar2.default, { color: "white", background: "teal" }),
	      _react2.default.createElement(
	        _Section2.default,
	        { color: "teal", padLarge: true },
	        _react2.default.createElement(
	          _Responsive.HideMobile,
	          null,
	          _react2.default.createElement(
	            _typography.H2,
	            { serif: true, weight: "bold", color: "white", align: "center" },
	            content.title
	          )
	        ),
	        _react2.default.createElement(
	          _Responsive.ShowMobile,
	          null,
	          _react2.default.createElement(
	            _typography.H4,
	            { serif: true, weight: "bold", color: "white", align: "center" },
	            content.title
	          )
	        ),
	        _react2.default.createElement(
	          _typography.H3,
	          { color: "white" },
	          content.subtitle
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { fixed: true },
	        _react2.default.createElement(
	          _Emphasis2.default,
	          null,
	          _react2.default.createElement(
	            _typography.H4,
	            null,
	            content.animationTitle
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Responsive.HideMobile,
	        null,
	        _react2.default.createElement(_ProductAnimationSlider2.default, {
	          animationTitles: [content.animationTitle1, content.animationTitle2, content.animationTitle3, content.animationTitle4],
	          animationDescriptions: [content.animationDescription1.animationDescription1, content.animationDescription2.animationDescription2, content.animationDescription3.animationDescription3, content.animationDescription4.animationDescription4]
	        })
	      ),
	      _react2.default.createElement(
	        _Responsive.ShowMobile,
	        null,
	        _react2.default.createElement(_ProductAnimationMobile2.default, {
	          animationTitles: [content.animationTitle1, content.animationTitle2, content.animationTitle3, content.animationTitle4],
	          animationDescriptions: [content.animationDescription1.animationDescription1, content.animationDescription2.animationDescription2, content.animationDescription3.animationDescription3, content.animationDescription4.animationDescription4]
	        })
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(_IconGrid2.default, { benefits: content.benefitList })
	      ),
	      _react2.default.createElement(_Couple2.default, { visible: true, content: missionContent }),
	      _react2.default.createElement(_ContentSection2.default, {
	        join: true,
	        color: "greyLight",
	        titleText: content.missionTitle,
	        bodyText: content.missionBodyText.missionBodyText.split("|"),
	        link: {
	          label: content.missionLink,
	          to: "/mission"
	        }
	      })
	    );
	  };
	
	  return ProductPage;
	}(_react2.default.Component);
	
	exports.default = ProductPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ "./src/styles/theme.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n      @media (max-width: 600px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 600px) {\n        ", "\n      }\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 900px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 900px) {\n        ", "\n      }\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 1200px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 1200px) {\n        ", "\n      }\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 945px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 945px) {\n        ", "\n      }\n  "]);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = {
	  colors: {
	    red: "red",
	    salmon: "#de4b4b",
	    blue: "#4A90E2",
	    blueDark: "#005baa",
	    herrBlue: "#4363a0",
	    purpleDark: "#061e28",
	    green: "green",
	    teal: "#43bcba",
	    black: "#000000",
	    white: "#FFFFFF",
	    greyLight: "#f3f3f3",
	    greyAccent: "#d3d3d3",
	    halfGrey: "linear-gradient(to bottom, transparent 50%, #f3f3f3 50%)",
	    greyDient: "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
	    greyDientReverse: "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
	    grey: "#c3c3c3",
	    greyDark: "#979797",
	    greyTimeline: "#4A4A4A",
	    dark: "#000914",
	    transparent: "rgba(0, 0, 0, 0)"
	  },
	  media: {
	    mobile: function mobile() {
	      return (0, _styledComponents.css)(_templateObject, _styledComponents.css.apply(undefined, arguments));
	    },
	    tablet: function tablet() {
	      return (0, _styledComponents.css)(_templateObject2, _styledComponents.css.apply(undefined, arguments));
	    },
	    desktop: function desktop() {
	      return (0, _styledComponents.css)(_templateObject3, _styledComponents.css.apply(undefined, arguments));
	    },
	    card: function card() {
	      return (0, _styledComponents.css)(_templateObject4, _styledComponents.css.apply(undefined, arguments));
	    }
	  }
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-product-js-3feaeeb48202b038c3a5.js